const TYPES = [
  {
    icon: 'ri-tree-line',
    title: 'Hardwood Flooring',
    tag: 'Classic & Timeless',
    desc: 'Glue-down and nail-down installation with precision layout. Rich grain texture that adds warmth and long-term value to any space.',
    features: ['Glue-down method', 'Nail-down method', 'Solid & engineered options', 'Custom stain finishes'],
    image: 'https://public.readdy.ai/ai/img_res/bbbc5d63b424633ee0d80acc6b3e3ebd.jpg',
  },
  {
    icon: 'ri-stack-line',
    title: 'Luxury Vinyl Plank (LVP)',
    tag: 'Most Popular',
    desc: 'Waterproof, durable, and beautiful. LVP is perfect for high-traffic areas, kitchens, and spaces where moisture resistance matters.',
    features: ['100% waterproof', 'Click-lock installation', 'Pet & kid friendly', 'Realistic wood look'],
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20vinyl%20plank%20flooring%20installed%20in%20bright%20contemporary%20living%20room%2C%20realistic%20wood%20look%20LVP%20floor%20planks%20in%20light%20grey%20tone%2C%20clean%20modern%20interior%20with%20minimal%20furniture%2C%20natural%20light%20from%20windows%20highlighting%20the%20flooring%20texture%20and%20finish&width=600&height=420&seq=floor_lvp001&orientation=landscape',
  },
  {
    icon: 'ri-layout-grid-line',
    title: 'Laminate Flooring',
    tag: 'Budget-Smart',
    desc: 'High-quality laminate installed with precision. Great aesthetics at a smart price point — without compromising on durability.',
    features: ['Floating installation', 'Scratch resistant', 'Easy maintenance', 'Wide style selection'],
    image: 'https://readdy.ai/api/search-image?query=premium%20laminate%20flooring%20beautifully%20installed%20in%20modern%20home%20dining%20room%2C%20realistic%20wood%20finish%20laminate%20planks%20in%20warm%20brown%20tones%2C%20clean%20fresh%20installation%20with%20precise%20seams%2C%20contemporary%20residential%20interior%20with%20natural%20daylight&width=600&height=420&seq=floor_lam001&orientation=landscape',
  },
  {
    icon: 'ri-window-line',
    title: 'Engineered Wood',
    tag: 'Best of Both Worlds',
    desc: 'The beauty of real wood with enhanced stability. Engineered hardwood performs better in humidity and temperature fluctuations.',
    features: ['Superior stability', 'Real wood surface', 'Humidity resistant', 'Multiple installation methods'],
    image: 'https://readdy.ai/api/search-image?query=engineered%20hardwood%20flooring%20in%20elegant%20open%20plan%20home%2C%20light%20blonde%20engineered%20wood%20floor%20with%20natural%20grain%20visible%2C%20bright%20airy%20Scandinavian%20interior%20design%2C%20wide%20plank%20format%20engineered%20wood%2C%20beautiful%20modern%20residential%20flooring%20installation&width=600&height=420&seq=floor_eng001&orientation=landscape',
  },
  {
    icon: 'ri-grid-line',
    title: 'Tile Installation',
    tag: 'Durable & Stylish',
    desc: 'Precise tile setting for floors, walls, and wet areas. From large-format porcelain to classic ceramic — perfectly laid every time.',
    features: ['Porcelain & ceramic', 'Large-format tile', 'Wet area certified', 'Custom patterns & layouts'],
    image: 'https://readdy.ai/api/search-image?query=professional%20tile%20installation%20in%20modern%20home%2C%20large%20format%20porcelain%20tiles%20being%20precisely%20laid%20on%20floor%20with%20spacers%2C%20clean%20grout%20lines%2C%20bright%20contemporary%20interior%2C%20skilled%20tiler%20at%20work%20with%20professional%20tools%2C%20fresh%20crisp%20tile%20installation&width=1200&height=420&seq=floor_tile001&orientation=landscape',
  },
];

export default function FlooringTypes() {
  return (
    <section className="py-24 px-4 md:px-8 bg-[#111111] border-t border-white/8">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-[#c9a55a] text-xs font-bold uppercase tracking-[0.3em] mb-4">Floor Types</p>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-5">What We Install</h2>
          <p className="text-white/45 text-base max-w-xl mx-auto leading-relaxed">
            Every floor type installed with the same level of precision, preparation, and craftsmanship.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {TYPES.map((type, idx) => (
            <div
              key={type.title}
              className={`group bg-[#1a1a1a] border border-white/8 hover:border-[#c9a55a]/30 rounded-2xl overflow-hidden transition-all duration-300${idx === TYPES.length - 1 && TYPES.length % 2 !== 0 ? ' md:col-span-2' : ''}`}
            >
              {/* Image */}
              <div className="relative h-52 overflow-hidden">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] via-transparent to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="bg-[#c9a55a] text-[#0d0d0d] text-xs font-bold px-3 py-1.5 rounded-full whitespace-nowrap">
                    {type.tag}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-8">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center bg-[#c9a55a]/10 rounded-xl">
                    <i className={`${type.icon} text-[#c9a55a] text-lg`} />
                  </div>
                  <h3 className="text-white font-black text-xl">{type.title}</h3>
                </div>
                <p className="text-white/50 text-sm leading-relaxed mb-6">{type.desc}</p>
                <div className="grid grid-cols-2 gap-2">
                  {type.features.map((f) => (
                    <div key={f} className="flex items-center gap-2">
                      <div className="w-4 h-4 flex items-center justify-center flex-shrink-0">
                        <i className="ri-check-line text-[#c9a55a] text-xs" />
                      </div>
                      <span className="text-white/55 text-xs">{f}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
